import styled from 'styled-components';
import { useParams, useNavigate, Outlet } from 'react-router-dom';
import palette from 'lib/styles/palette';
import useDeviceRegister from 'hooks/device/useDeviceRegister';
import Loading from 'components/common/Loading';
import ErrorNoti from 'components/common/ErrorNoti';
import { useState } from 'react';
import AskModal from 'components/common/AskModal';
import NotiModal from 'components/common/NotiModal';

const DeviceRegister = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showErrorModal, setShowErrorModal] = useState(false);

  const { getDeviceQuery, onDelete } = useDeviceRegister(id, setShowErrorModal);

  if (
    getDeviceQuery.isLoading ||
    getDeviceQuery.error?.response.status === 401 ||
    getDeviceQuery.error?.response.data.error === 'AuthorizationNotFound'
  )
    return <Loading />;

  if (getDeviceQuery.error?.response.status === 500) return <ErrorNoti />;

  return (
    <>
      {showErrorModal && (
        <NotiModal
          closeModal={() => setShowErrorModal(false)}
          msg="서버 오류로 삭제에 실패했습니다"
          fontL
        />
      )}
      {showDeleteModal && (
        <AskModal
          closeModal={() => setShowDeleteModal(false)}
          action="삭제"
          message="정말 삭제하시겠습니까?"
          actionFc={() => {
            setShowDeleteModal(false);
            onDelete();
          }}
        />
      )}
      <DeviceRegisterBlock>
        <div className="header">
          <div className="header-left">장비 등록</div>
          <div>{getDeviceQuery.data?.data.company}</div>
          <div className="header-right">{getDeviceQuery.data?.data.place}</div>
        </div>
        <Outlet />
        <div className="btn-wrapper">
          <StyledButton onClick={() => setShowDeleteModal(true)}>
            전체 삭제
          </StyledButton>
          <StyledButton onClick={() => navigate('/admin/devices')}>
            목록
          </StyledButton>
        </div>
      </DeviceRegisterBlock>
    </>
  );
};

export default DeviceRegister;

const DeviceRegisterBlock = styled.div`
  width: 1080px;
  margin: 2rem auto;
  padding: 2rem 1rem;
  display: flex;
  flex-direction: column;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 20px;
  background-color: #fff;
  box-shadow: 0 0 50px 0 rgba(0, 0, 0, 0.08);

  .header {
    padding: 0 1rem;
    display: flex;
    justify-content: center;
    font-weight: bold;
    font-size: 1.2rem;
    position: relative;
  }

  .header-left {
    position: absolute;
    left: 10px;
  }

  .icon {
    font-size: 22px;
    cursor: pointer;
  }

  .header-right {
    position: absolute;
    right: 10px;
  }

  .btn-wrapper {
    margin-top: 2rem;
    display: flex;
    justify-content: center;
  }
`;

const StyledButton = styled.button`
  padding: 10px 30px;
  border: none;
  border-radius: 5px;
  background: ${palette.theme[3]};
  color: #fff;
  cursor: pointer;
  &:hover {
    background: ${palette.theme[2]};
  }
  & + & {
    margin-left: 15px;
  }
`;
